import type { QuizPhase } from '../hooks/useQuizSession'

const STORAGE_KEY = 'recall_quiz_session'

// localStorage, not sessionStorage: resume must survive a closed tab or it costs a second
// generate (402 on free). Keyed by UTC day, when the allowance refills.
interface SavedSession { day: string; state: QuizPhase }

function utcDay(): string {
  return new Date().toISOString().slice(0, 10)
}

export function loadSaved(): QuizPhase | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    const saved = JSON.parse(raw) as Partial<SavedSession>
    if (saved.day !== utcDay() || !saved.state) {
      localStorage.removeItem(STORAGE_KEY)
      return null
    }
    return saved.state
  } catch {
    return null
  }
}

export function save(state: QuizPhase) {
  try {
    const saved: SavedSession = { day: utcDay(), state }
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved))
  } catch { /* ignore */ }
}

export function clearSaved() {
  try { localStorage.removeItem(STORAGE_KEY) } catch { /* ignore */ }
}

/** A saved session outlives the tab, so it must not outlive the account that generated it. */
export function clearSavedQuizSession() {
  clearSaved()
}
